export default __webpack_public_path__ + "static/media/cabinet1-after-1024w.20a76262.png";